import { Button } from '@mui/material'
import '../styles/Dashboard.scss'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { getDataById } from '../apis/generalApis'
import ServicesCard from './Cards/ServicesCard'
import { ScaleLoader } from 'react-spinners'

const Dashboard = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  useEffect(() => {
    getData()
  }, [])
  const [isLoading, setIsLoading] = useState(false)
  const [state, setState] = useState({
    bookings: [],
    earning: 0,
    reliability: 0,
  })

  const getData = async () => {
    const body = {
      user_id: user?.id,
    }
    setIsLoading(true)
    const result = await getDataById('stylist-home', body)
    setIsLoading(false)
    if (result?.success === true) {
      setState((prev) => ({
        ...prev,
        bookings: result?.booking,
        earning: result?.earning,
        reliability: result?.reliability,
      }))
    }
  }


  return (
    <div className="dashboard bg-white">
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 9,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <div className="container">
        <div className="row justify-content-md-end justify-content-sm-between justify-content-center mt-4">
          <div className="col-4 d-flex align-items-center justify-content-center">
            <h3 className="font-weight-bold fs-32 text-black">
              Business Updates
            </h3>
          </div>
          <div className="col-4 text-right">
            <Link to={'/search'} className="text-decoration-none">
              <Button
                disableElevation
                id="btn-primary-no-shadow"
                variant="contained"
                className="commonBtn px-5 py-md-0 py-sm-4 py-4"
              >
                Create Reservation
              </Button>
            </Link>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center mt-5 flex-wrap gap-4">
          <div
            className="businessCard text-center"
            style={{ padding: '3rem 5rem' }}
          >
            <h3 className="fs-1 text-white">{`$${state.reliability}`}</h3>
            <p className="mt-3 mb-3 fw-bold">Reliability Rate</p>
          </div>
          <div
            className="businessCard text-center"
            style={{ padding: '3rem 5rem' }}
          >
            <h3 className="fs-1 text-white">{'$' + state.earning}</h3>
            <p className="mt-3 mb-3 fw-bold">Monthly Earning</p>
          </div>
        </div>
        <h3 className="font-weight-bold fs-32 text-black text-center mt-5">
          Today's Schedule
        </h3>
        <div className="scheduleCards mt-5 mb-5">
          <div className="d-flex justify-content-between">
            <h3 className="fs-24 text-black fw-bold">
              What's on the schedule?
            </h3>
            <h3 className="fs-15 color-primary">See Calendar?</h3>
          </div>
          <div className="mt-2 scheduleCardsWrapper row pb-3">
            {state?.bookings &&
              state?.bookings?.map((booking, index) => (
                <div
                  className="col-12 col-sm-12 col-md-4 mt-3 mt-md-0"
                  key={booking?.id}
                >
                  <Link
                    to={'/styles'}
                    className="text-decoration-none text-black"
                  >
                    <ServicesCard booking={booking} />
                  </Link>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dashboard
